"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DocumentTranslatable", {
  enumerable: true,
  get: function get() {
    return _documentTranslatable.default;
  }
});
Object.defineProperty(exports, "SectionTranslatable", {
  enumerable: true,
  get: function get() {
    return _sectionTranslatable.default;
  }
});
Object.defineProperty(exports, "BlockTranslatable", {
  enumerable: true,
  get: function get() {
    return _blockTranslatable.default;
  }
});
Object.defineProperty(exports, "BlockEditable", {
  enumerable: true,
  get: function get() {
    return _blockEditable.default;
  }
});
Object.defineProperty(exports, "Translatable", {
  enumerable: true,
  get: function get() {
    return _translatable.default;
  }
});
Object.defineProperty(exports, "Actions", {
  enumerable: true,
  get: function get() {
    return _actions.default;
  }
});

var _documentTranslatable = _interopRequireDefault(require("./document-translatable"));

var _sectionTranslatable = _interopRequireDefault(require("./section-translatable"));

var _blockTranslatable = _interopRequireDefault(require("./block-translatable"));

var _blockEditable = _interopRequireDefault(require("./block-editable"));

var _translatable = _interopRequireDefault(require("./translatable"));

var _actions = _interopRequireDefault(require("./actions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}